import ExcludedAccessoriesModal from './ExcludedAccessoriesModal.vue'

export default ExcludedAccessoriesModal
